// src/components/Confirm/index.js
import { createVNode, render } from 'vue'
import ConfirmComponent from './index.vue'

const Confirm = {
  install(app) {
    app.config.globalProperties.$dialog = (options) => {
      // 判断是否使用 Promise 方式调用
      const isPromiseCall = !options.onConfirm && !options.onCancel
      
      // 创建容器
      const div = document.createElement('div')
      document.body.appendChild(div)
      
      // 返回 Promise 的函数
      const confirmPromise = new Promise((resolve, reject) => {
        // 创建组件实例
        const vnode = createVNode(ConfirmComponent, {
          ...options,
          onConfirm: () => {
            if (options.onConfirm) {
              options.onConfirm()
            }
            if (isPromiseCall) {
              resolve(true)
            }
            // 移除 DOM
            render(null, div)
            div.remove()
          },
          onCancel: () => {
            if (options.onCancel) {
              options.onCancel()
            }
            if (isPromiseCall) {
              reject(false)
            }
            // 移除 DOM
            render(null, div)
            div.remove()
          }
        })
        
        // 渲染组件
        render(vnode, div)
        
        // 打开对话框
        vnode.component.exposed.open()
      })
      
      // 如果是 Promise 调用方式，则返回 Promise
      if (isPromiseCall) {
        return confirmPromise
      }
      
      // 否则不返回任何内容（保持原有调用方式）
      return undefined
    }
  }
}

export default Confirm
// const Confirm = {
//   install(app) {
//     // 创建 confirm 方法并挂载到 app 实例上
//     app.config.globalProperties.$dialog = (options) => {
//       // 创建 div
//       const div = document.createElement('div')
//       document.body.appendChild(div)
      
//       // 创建组件实例
//       const vnode = createVNode(ConfirmComponent, {
//         ...options,
//         onConfirm: () => {
//           options.onConfirm && options.onConfirm()
//           // 移除 DOM
//           render(null, div)
//           div.remove()
//         },
//         onCancel: () => {
//           options.onCancel && options.onCancel()
//           // 移除 DOM
//           render(null, div)
//           div.remove()
//         }
//       })
      
//       // 渲染组件
//       render(vnode, div)
      
//       // 打开对话框
//       vnode.component.exposed.open()
//     }
//   }
// }

// export default Confirm

// 用例1
// this.$dialog({
//   title: 'Delete Gateway Group',
//   content: 'All devices in the gateway group will be deleted and <span style="color:red;">cannot be restored</span> .Do you want to continue?',
//   confirmButtonText: '删除',
//   cancelButtonText: '放弃',
// }).then(res => {
//   if (res) {
//     console.log('点击确认')
//   } else {
//     console.log('点击取消')
//   }
// })

// 用例2
// this.$dialog({
//   title: 'Delete Gateway Group',
//   content: 'All devices in the gateway group will be deleted and <span style="color:red;">cannot be restored</span> .Do you want to continue?',
//   confirmButtonText: '删除',
//   cancelButtonText: '放弃',
//   onConfirm() {
//     console.log('点击确认')
//   },
//   onCancel() {
//     console.log('点击取消')
//   }
// })